import http from "../../api/axios";
import { IRegionQuery } from "../../model/regions/query";

class BranchService {
  getData = (params: IRegionQuery): Promise<any> =>
    http.get("/branch", { params });

  createBranch = (data: any): Promise<any> => http.post("/branch/", data);

  updateBranch = (data: any, id: number): Promise<any> =>
    http.put(`/branch/${id}`, data);

  deleteBranch = (id: number): Promise<any> => http.delete(`/branch/${id}`);
}

export default BranchService;
